export default "__VITE_ASSET__C9Bnw$Kv__"